import React from 'react';
import PropTypes from 'prop-types';
import { ActionButton, SecondaryButton } from '../../Buttons/Buttons';
import CustomModal from '../../Modals/Modals';
import Notice from '../../Notice/Notice';
import styles from './TopBar.module.css';
import { ApplicationStatus } from '../../../../../Lib/Constants/vendor-application-form-step';

function ReviewApplicationModal({
  open,
  onClose,
  confirmationText,
  status,
  currentApplication,
  onApprove,
  onCancelApprove,
}) {
  return (
    <CustomModal open={open} handleClose={onClose}>
      <div className={styles.modalBody}>
        <div>
          <div className={styles.modalTitle}>{confirmationText} Vendor</div>
          {/* eslint-disable-next-line no-nested-ternary */}
          {confirmationText === 'approve' ? (
            status === ApplicationStatus.FIRST_EXECUTIVE_APPROVAL ||
            status === ApplicationStatus.SPONSOR_APPROVAL ||
            status === ApplicationStatus.SPONSOR_DENIED ? (
              <>
                <div className={styles.modalText}>
                  Approving <b>{currentApplication.vendor_name}</b> will send a
                  notification to the Executive team to request a final
                  approval.
                </div>
                <div>
                  <Notice type="info">
                    The vendor will not be notified until they are approved or
                    denied by the Executive team.
                  </Notice>
                </div>
              </>
            ) : (
              <div className={styles.modalText}>
                Approving <b>{currentApplication.vendor_name}</b> will send a
                notification to the vendor requesting pre-onboarding documents.
              </div>
            )
          ) : (
            <div className={styles.modalText}>
              Denying <b>{currentApplication.company_name}</b> will send a
              notification to this vendor that their application was denied.
            </div>
          )}
        </div>
        <div className={styles.modalBottom}>
          <div className={styles.modalButtons}>
            <ActionButton onClick={onCancelApprove}>No, cancel</ActionButton>
            <SecondaryButton
              onClick={() => {
                onApprove(confirmationText);
                onClose();
              }}
            >
              Yes, {confirmationText}
            </SecondaryButton>
          </div>
        </div>
      </div>
    </CustomModal>
  );
}

ReviewApplicationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  confirmationText: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  currentApplication: PropTypes.shape({
    vendor_name: PropTypes.string,
    company_name: PropTypes.string,
  }).isRequired,
  onApprove: PropTypes.func.isRequired,
  onCancelApprove: PropTypes.func.isRequired,
};

export default ReviewApplicationModal;
